const responseMock = [[{
  group: 1,
  name: "Riff and Co. \u0E2A\u0E33\u0E42\u0E23\u0E07",
  value: 2e4
}, {
  group: 2,
  name: "Riff and Co. \u0E1E\u0E0D\u0E32\u0E44\u0E17",
  value: 16500
}, {
  group: 3,
  name: "Riff and Co. \u0E2D\u0E32\u0E23\u0E35\u0E22\u0E4C",
  value: 14250
}, {
  group: 4,
  name: "Riff and Co. \u0E2A\u0E19\u0E32\u0E21\u0E1A\u0E34\u0E19\u0E14\u0E2D\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
  value: 39e3
}, {
  group: 5,
  name: "Riff and Co. \u0E19\u0E19\u0E17\u0E1A\u0E38\u0E23\u0E35",
  value: 15e3
}], [{
  group: 1,
  name: "Riff and Co. \u0E2A\u0E33\u0E42\u0E23\u0E07",
  value: 15e3
}, {
  group: 2,
  name: "Riff and Co. \u0E1E\u0E0D\u0E32\u0E44\u0E17",
  value: 12500
}, {
  group: 3,
  name: "Riff and Co. \u0E2D\u0E32\u0E23\u0E35\u0E22\u0E4C",
  value: 19e3
}, {
  group: 4,
  name: "Riff and Co. \u0E2A\u0E19\u0E32\u0E21\u0E1A\u0E34\u0E19\u0E14\u0E2D\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
  value: 0
}, {
  group: 5,
  name: "Riff and Co. \u0E19\u0E19\u0E17\u0E1A\u0E38\u0E23\u0E35",
  value: 2e3
}], [{
  group: 1,
  name: "Riff and Co. \u0E2A\u0E33\u0E42\u0E23\u0E07",
  value: 11500
}, {
  group: 2,
  name: "Riff and Co. \u0E1E\u0E0D\u0E32\u0E44\u0E17",
  value: 13250
}, {
  group: 3,
  name: "Riff and Co. \u0E2D\u0E32\u0E23\u0E35\u0E22\u0E4C",
  value: 2e4
}, {
  group: 4,
  name: "Riff and Co. \u0E2A\u0E19\u0E32\u0E21\u0E1A\u0E34\u0E19\u0E14\u0E2D\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
  value: 0
}, {
  group: 5,
  name: "Riff and Co. \u0E19\u0E19\u0E17\u0E1A\u0E38\u0E23\u0E35",
  value: 1e4
}], [{
  group: 1,
  name: "Riff and Co. \u0E2A\u0E33\u0E42\u0E23\u0E07",
  value: 2e4
}, {
  group: 2,
  name: "Riff and Co. \u0E1E\u0E0D\u0E32\u0E44\u0E17",
  value: 13250
}, {
  group: 3,
  name: "Riff and Co. \u0E2D\u0E32\u0E23\u0E35\u0E22\u0E4C",
  value: 15e3
}, {
  group: 4,
  name: "Riff and Co. \u0E2A\u0E19\u0E32\u0E21\u0E1A\u0E34\u0E19\u0E14\u0E2D\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
  value: 1e4
}, {
  group: 5,
  name: "Riff and Co. \u0E19\u0E19\u0E17\u0E1A\u0E38\u0E23\u0E35",
  value: 2300
}]];
function sortStackChart(data, sort = "desc", direction) {
  const values = data.flatMap(item => item);
  const stackTotalValues = calculateStackTotal(values);
  const valuesWithStackTotal = data.map(items => {
    return items.map(item => {
      return {
        ...item,
        stackTotal: stackTotalValues[item.group]
      };
    });
  });
  const sortedValues = valuesWithStackTotal.map(items => {
    return sortValues(items, sort, direction);
  });
  return sortedValues;
}
const NUMBER_DIGITS = {
  1: 1,
  2: 10,
  3: 100,
  4: 1e3,
  5: 1e4,
  6: 1e5,
  7: 1e6
};
function getTickValues(data) {
  const values = data.flatMap(item => item);
  const stackTotalValues = calculateStackTotal(values);
  const max = Math.max(...Object.values(stackTotalValues));
  const numbers = String(max).split("").reverse().map(item => +item);
  const lastDigit = numbers[numbers.length - 1] + 1;
  const maxDomain = lastDigit * NUMBER_DIGITS[numbers.length];
  const tickValues = [];
  const step = 1e4;
  for (let i = 0; i <= maxDomain; i = i + step) {
    tickValues.push(i);
  }
  return tickValues;
}
function getTickLabels(data, sort = "desc", direction) {
  const values = data.flatMap(item => item);
  const stackTotalValues = calculateStackTotal(values);
  const uniqueValuesWithStackTotal = values.reduce((acc, curr) => {
    const isTickNotExists = !acc.find(item => item.group === curr.group);
    if (isTickNotExists) {
      acc.push({
        group: curr.group,
        name: curr.name,
        stackTotal: stackTotalValues[curr.group]
      });
    }
    return acc;
  }, []);
  const sortedValues = sortValues(uniqueValuesWithStackTotal, sort, direction);
  return sortedValues.map(item => item.name);
}
function calculateStackTotal(data) {
  return data.reduce((acc, curr) => {
    if (!acc[curr.group]) {
      acc[curr.group] = curr.value;
    } else {
      acc[curr.group] = acc[curr.group] + curr.value;
    }
    return acc;
  }, {});
}
function sortValues(data, sort = "desc", direction) {
  let sorted = data.sort((a, b) => {
    return sort === "desc" ? a.stackTotal - b.stackTotal : b.stackTotal - a.stackTotal;
  });
  if (direction === "vertical") {
    sorted.reverse();
  }
  return sorted.map((item, index) => {
    return {
      ...item,
      group: index + 1
    };
  });
}
export { getTickLabels, getTickValues, responseMock, sortStackChart };
//# sourceMappingURL=data.mjs.map
